import ElementUi from 'element-ui'

export const prefix = 'pagoda'
export const elementUiVersion = +ElementUi.version.split('.').slice(0, 2).join('.')
